import React, { Component } from "react"
import { StaticQuery, Link, graphql } from "gatsby"
import Logo from "./../logo/logo.module"
import styles from "./navbar.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ListLink = props => {
  if (props.config.sub && props.config.sub.length > 0) {
    return (
      <div
        to={props.config.to}
        className={` ${styles.dropdownHoverable} ${styles.navItem}`}
      >
        <div>
          <FontAwesomeIcon icon={props.config.icon} /> {props.config.name}
        </div>
        <div className={styles.dropdownContent}>
          {props.config.sub.map(child => (
            <a href={child.to} key={child.name} className={styles.navItem}>
              <FontAwesomeIcon icon={child.icon} /> {child.name}
            </a>
          ))}
        </div>
      </div>
    )
  } else {
    return (
      <a href={props.config.to} className={styles.navItem}>
        <FontAwesomeIcon icon={props.config.icon} /> {props.config.name}
      </a>
    )
  }
}

class navbar extends Component {
  constructor(props) {
    super(props)

    this.state = { collapse: false }
    this.showmenu = this.showmenu.bind(this)
  }

  showmenu() {
    let tmp = ""

    if (!this.state.collapse) {
      tmp = "translateY(-160px)"
    } else {
      tmp = "translateY(160px)"
    }

    document.getElementById("slideMenu").style.setProperty("transform", tmp)

    this.setState(prevState => ({
      collapse: !prevState.collapse,
    }))
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            site {
              siteMetadata {
                websiteConfig {
                  menu {
                    list {
                      name
                      icon
                      to
                    }
                    calltoaction {
                      name
                      icon
                      to
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => {
          if (typeof window !== "undefined") {
            window.addEventListener("scroll", () => {
              if (window.scrollY > 20) {
                document
                  .getElementById("backmob")
                  .style.setProperty("display", "block")
                document
                  .getElementById("action")
                  .style.setProperty("top", "10px")
              } else {
                document
                  .getElementById("backmob")
                  .style.setProperty("display", "none")

                document
                  .getElementById("action")
                  .style.setProperty("top", "inherit")
              }
            })
          }
          return (
            <div className="row">
              <div className="col-lg-12">
                <div className={styles.backmob} id="backmob" />
              </div>
              <div className="col-lg-12">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12 d-flex">
                      <Logo />
                      <nav
                        className={`w-100 d-flex align-items-center justify-content-end ${
                          styles.nav
                        }`}
                        id="nav"
                      >
                        <div
                          className={`${styles.navbar} align-items-center`}
                          id="navbar"
                        >
                          {data.site.siteMetadata.websiteConfig.menu.list.map(
                            el => (
                              <ListLink config={el} key={el.name} />
                            )
                          )}
                          {data.site.siteMetadata.websiteConfig.menu
                            .calltoaction && (
                            <button
                              id="action"
                              className={` btnAction ml-2 ${
                                styles.calltoaction
                              } `}
                            >
                              <FontAwesomeIcon
                                icon={
                                  data.site.siteMetadata.websiteConfig.menu
                                    .calltoaction.icon
                                }
                              />
                              {
                                data.site.siteMetadata.websiteConfig.menu
                                  .calltoaction.name
                              }
                            </button>
                          )}
                        </div>
                        <div className={styles.icon}>
                          <button
                            className={` btnAction ml-2`}
                            onClick={this.showmenu}
                          >
                            <FontAwesomeIcon icon="bars" />
                            Menu
                          </button>
                        </div>
                      </nav>
                      <div className={styles.slideMenu} id="slideMenu">
                        <div
                          style={{
                            marginLeft: "14px",
                            marginTop: "14px",
                            marginBottom: "14px",
                          }}
                        >
                          <div className={styles.ads} />
                        </div>
                        <ul
                          style={{
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                          }}
                        >
                          {data.site.siteMetadata.websiteConfig.menu.list.map(
                            el => (
                              <li key={el.name} className={styles.snavItem}>
                                <a href={el.to}>{el.name}</a>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }}
      />
    )
  }
}

export default navbar
